import Vue from "vue";
import functions from "@/functions";

Vue.filter("firstLetter", functions.firstLetter);
Vue.filter("maskEmail", functions.maskEmail);
Vue.filter("formatCNPJ", functions.formatCNPJ);
Vue.filter("formatNumber", functions.formatNumber);
Vue.filter("formatNumberInt", functions.formatNumberInt);
Vue.filter("formatMoneyBR", functions.formatMoneyBR);
Vue.filter("formatDate", functions.formatDate);
Vue.filter("formatDateTime", functions.formatDateTime);
